// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"1f7cb291","48":"fef17b41","174":"7a3b0af8","209":"83486c38","227":"b81235d3","348":"efad19b0","488":"0ed301f4","778":"c7c41a5c","789":"3b4a070e","793":"e8c1b91b","831":"9e31a11f","832":"0d5e53b6","847":"2cfbc371","923":"dbcf95cf"}[chunkId] + ".chunk.js";
};